'use strict';

import { appState } from './appState.js';
import { ajaxWrapNew } from './ajaxWrapNew.js';
import { urlSafe } from './urlTools.js';
import { ModalManager } from './ModalManager.js';
import { jconnanimInit } from './connanim.js';

var mobileNavInstance = null;

export function mobileNav(conf) {
    const self = this;

    if (!conf) {
        conf = {};
    }

    this.nav = conf.nav || '.main-nav';
    this.navSub = conf.navSub || '.nvi-ws';
    this.navContainer = conf.navContainer || '.mobNav';

    this.opener = conf.opener || '.main-nav-opener';
    this.closer = conf.closer || '.nav-closer-animated';

    this.conf = {
        slide_speed: {
            on: 500,
            off: 200
        }
    };

    this.created = false;
    this.opened = false;
    this.disableScroll = true;
    this.modalManagerToken = null;
    this.openAllSubs = false;
    this.saveOpenedSubs = true;

    this.history = null;
    this.el = null;
    this.eloverlay = null;
    this.elbg = null;

    this.onCloseRedirect = null;
    this.onCloseAssign = null;
    this.onCloseReload = false;

    self.param = 'menu';

    appState.historyInstance.add('menu', {
        value: null,
        backCallback: function (change) {
            self.close(true, true);
        },
        checkCallback: function (value) {
            return self.opened ? true : null;
        },
        goBackOnRefresh: true
    });

    self.init = function () {
        var insideClick = false;

        $(self.opener).on('click', function (event) {
            event.preventDefault();
            insideClick = true;

            if ($(this).hasClass('pointer-events-disable-a')) {
                return;
            }

            event.stopPropagation();
            insideClick = false;

            if (!self.created) {
                self.createMenu();
            }

            if (!self.opened) {
                self.open();
            } else {
                self.close();
            }
        });

        $(self.navContainer).on('click', '.mc1', function (event) {
            insideClick = true;
        });

        $(self.navContainer).on('click', self.closer, function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (self.opened) {
                self.close();
            }
        });

        $(self.navContainer).on('click', '.nv-sub-opener', function (event) {
            event.stopPropagation();
            const nvs = $(this).closest('.nvi-ws');
            if (nvs.length > 0) {
                nvs.toggleClass('nv-sub-opened');
                // saglabājam izvēli;
                if (self.saveOpenedSubs) {
                    ajaxWrapNew({
                        method: 'POST',
                        data: {
                            ajax: 1,
                            action: 'cht-subopened',
                            on: nvs.hasClass('nv-sub-opened') ? 1 : 0,
                            nvid: $(this).parent().find('.nv-a').data('nvid') || ''
                        },
                        success: function (data) { },
                        dataType: 'json'
                    });
                }
            }
        });

        $(self.navContainer).on('click', 'a', function (event) {
            if (!self.opened) {
                return;
            }

            self.onCloseRedirect = null;
            self.onCloseAssign = null;
            self.onCloseReload = false;
            if ($(this).hasClass('isself')) {
                event.preventDefault();
                self.close();
                return;
            }

            let href = $(this).attr('href');
            if (href != '#' && href != 'javascript:;') {
                event.preventDefault();
                self.onCloseAssign = href;
                self.close();
            }
        });

        /* $( this.navContainer ).on('click', '.nv-a', function ( event ) {
            if ( $(this).closest('.ms-menu').length > 0 ) {
                const nvid = $(this).data('nvid');

                if ($(this).closest('.nvi').find('.nvi-sub[data-nvparent="'+nvid+'"]').length > 0) {
                    event.preventDefault();
                    event.stopPropagation();

                    new mobileNavSub( this, nvid, $(this).closest('.nvi').find('.nvi-sub[data-nvparent="'+nvid+'"]').get(0) );
                }
            }
        }); */

        /* $( this.navContainer ).on('change', '.lang-menu-sel', function ( event ) {
            window.location = $(this).val();
        }); */

        $(window).on('jq-outclick', function (event) {
            if (insideClick) {
                insideClick = false;
                return;
            }

            if (self.opened) {
                self.close();
            }
        });
    };

    self.createMenu = function () {
        self.created = true;

        //var $lng = $( '<div></div>' );
        /* $( '.lang-nav' ).each(function() {
            $lng.append( $(this).clone(true, true).removeClass('hidden') );
        }); */

        $(self.navContainer).append($('<div></div>').addClass('mc1over hidden').css({
            opacity: 0
        }));
        $(self.navContainer).append($('<div></div>').addClass('mc1overbg hidden').css({
            opacity: 0
        }));
        /* $( self.navContainer ).append( $( '<div></div>' ).addClass('mc1shadow hidden').css({
            opacity : 0
        }) ); */

        $(self.navContainer).append($('<div></div>').addClass('mc1container thinscroll')
        /* .css({
            opacity : 0
        }) */ );
        self.el = $(self.navContainer).find('.mc1container').get(0) || $([]);

        $(self.el).append($('<div></div>').addClass('mc1').append(
            $('<div class="menu-top-nv-x"></div>').prepend(
                '<div class="ms-header">' +
                ($('header').data('w2') ? '<a class="nav-welcome" href="' + ($('header').data('w1') || '/') + '">' + ($('header').data('w2') || '') + '</a>' : '') +
                //'<a class="nav-home" href="'+($('header .nav-opener').attr('href') || '/')+'"><span class="home-ic"></span><span class="logo-ic"></span></a>'+
                //'<a class="main-nav-closer nav-opener-opened" href="javascript:;"></a>'+
                '<a class="nav-closer-animated" href="javascript:;">' +
                '<span class="nca-1"></span>' +
                '<span class="nca-2c"><span class="nca-2"></span><span class="nca-3"></span></span>' +
                '</a>' +
                '</div>'
                //+'<div class="ms-search bg1"></div>'
            ).
                append(
                    $('.main-nav').clone(true, true).removeClass('main-nav hidden').addClass('ms-menu')
                        .each(function () {
                            $(this).find('.nvi-ws').children('.nv-a').each(function () {
                                $(this).wrap('<div class="nv-sub-wrapper"></div>').after(
                                    '<span class="nv-sepx"></span><a href="javascript:;" class="nv-sub-opener"></a>'
                                );
                                if ($(this).is('.selected') || $(this).is('.subopened') || self.openAllSubs) {
                                    $(this).closest('.nvi-ws').toggleClass('nv-sub-opened', true);
                                }
                                if ($(this).is('.selected')) {
                                    $(this).closest('.nvi-ws').toggleClass('nv-sub-selected', true);
                                }
                                if ($(this).closest('.nvi-ws').children('.nvi-sub').find('.selected').length > 0) {
                                    $(this).closest('.nvi-ws').toggleClass('nv-sub-selected', true);
                                }
                            });

                            $(this).find('.nv-a[data-adminswitch]').each(function () {
                                let adminswitch = $(this).data('adminswitch');
                                $(this).wrap('<div class="nv-admin-wrapper"></div>').after(
                                    '<a href="' + adminswitch.url + '" class="nv-switch ' + (adminswitch.on ? 'on' : 'off') + '" title="' + adminswitch.title + '"></a>'
                                );
                            });

                            $(this).find('.nv-a[data-action="cht-options"]').each(function () {
                                $(this).wrap('<div class="nv-options-wrapper"></div>');
                            });
                        })
                        .append(
                            $('<div class="socListContainer"></div>').append(
                                $('.socNav').clone().removeClass('socNav')
                            )
                        )
                        .each(function () {
                            if ($('.admStats').length > 0) {
                                $(this).append(
                                    $('<div class="admStatsContainer"></div>').append(
                                        $('.admStats')
                                    )
                                );
                            }
                        })
                    /* .
                    append(
                        $('<div class="lang-menu-x custom-sel"></div>').append(
                            $( '.language-ic' ).clone().removeClass('language-ic').addClass('language-ic2')
                        )
                    ) */
                )
        ));

        $(self.el).wrap('<div class="mc1containerShadow hidden"></div>');
        self.el = $(self.el).closest('.mc1containerShadow').get(0);

        self.eloverlay = $(self.navContainer).find('.mc1over').get(0);
        self.elbg = $(self.navContainer).find('.mc1overbg').get(0);

        if ($(self.el).find('.jconnanim.v1').length) {
            $(self.el).find('.jconnanim.v1').first().removeClass('default');
            jconnanimInit($(self.el).find('.jconnanim.v1').get(0));
        }


        var delay = 100;
        var distance = 10;
        var started = false;
        var startedDrag = false;
        var startPosX = null;
        var currentPosX = null;
        var leftOffset = null;
        var leftOffsetStart = null;

        var getX = function (event) {
            if (event.originalEvent && event.originalEvent.touches && event.originalEvent.touches.length) {
                return event.originalEvent.touches[0].pageX;
            }
            return event.pageX;
        };
        var cancelDrag = () => {
            $(self.el).data("dragenable", 0);
            $(self.el).animate({
                left: leftOffsetStart
            }, {
                duration: 200,
                easing: 'swing',
                complete: function () {
                    $(self.el).data("dragenable", 1);
                },
                always: function () {
                    $(self.el).data("dragenable", 1);
                }
            });
        };
        var finishDrag = () => {
            $(self.el).data("dragenable", 1);
            self.close();
        };

        $(self.el).on('mousedown touchstart', function (event) {
            if (started) return;
            if (!$(this).data("dragenable")) return;
            started = true;
            startPosX = getX(event);

            if (leftOffsetStart == null) {
                leftOffsetStart = $(self.el).position().left;
                //console.log('leftOffsetStart', leftOffsetStart);
            }
        });
        $(self.el).on('mousemove touchmove', function (event) {
            if (!started) return;
            currentPosX = getX(event);
            leftOffset = currentPosX - startPosX;
            if (Math.abs(leftOffset) > distance) {
                //console.log({ left: Math.min(leftOffsetStart, leftOffsetStart + leftOffset) });
                startedDrag = true;
                $(self.el).css({ left: Math.min(leftOffsetStart, leftOffsetStart + leftOffset) });
            }
        });

        $(self.el).on('mouseup touchend touchcancel', function (event) {
            if (!started) return;
            started = false;
            if (!startedDrag) return;
            startedDrag = false;

            //currentPosX = getX(event);
            const distance = currentPosX - startPosX;
            if (distance < -50) {
                finishDrag();
            } else {
                cancelDrag();
            }
        });
        $(self.el).data("dragenable", 1);
    };

    self.getMaxLeft = function () {
        return $(self.el).closest('.irel').offset().left + $(self.el).width() + 20;
    };

    self.open = function (force, nohistory) {
        self.opened = true;

        var maxLeft = self.getMaxLeft();

        $(self.el).css({
            left: '-' + maxLeft + 'px'
        });

        $(self.el).parent().css({
            zIndex: 8
        });
        $([self.el, self.eloverlay, self.elbg]).css({
            opacity: 0
        }).removeClass('hidden');

        $(self.el).height($(window).height());

        //$( self.el ).find('.mc1').height( $( window ).height() );
        $([self.eloverlay, self.elbg]).css('min-height', $(window).height());

        $(self.opener).addClass('nav-opener-opened nav-opened');
        $('body').addClass('main-nav-opened');

        $([self.eloverlay, self.elbg]).css({
            opacity: 1
        });

        if (self.disableScroll) {
            if (self.modalManagerToken) {
                ModalManager.close(self.modalManagerToken);
            }

            self.modalManagerToken = ModalManager.open({
                name: self.param || 'menu',
                locksScroll: true
            });
        }


        setTimeout(function () {
            $('.nav-closer-animated', self.el).addClass('ncafull');
        }, 400);

        setTimeout(function () {
            $('.jq-size-calc').addClass('wbclosespeed');
            $('.nav-closer-animated', self.el).addClass('wbclosespeed');
        }, 800);

        $(self.navContainer).find('.mc1 .lang-nav').removeClass('hidden');

        $(self.el).stop(true, false).animate({
            opacity: 1,
            left: '-17px'
        }, self.conf.slide_speed.on, 'swing', function () {
            $(this).css({
                opacity: 1
            });
        });

        if (!nohistory) {
            appState.historyInstance.push('menu');
        }
    };

    self.close = function (force, nohistory) {
        if (!nohistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
            appState.historyInstance.go(-1);
            return;
        }

        if (self.onCloseRedirect) {
            setTimeout(function () {
                urlSafe.redirect(self.onCloseRedirect);
                self.onCloseRedirect = null;
                self.onCloseAssign = null;
                self.onCloseReload = false;
            }, 20);
        } else if (self.onCloseAssign) {
            setTimeout(function () {
                urlSafe.assign(self.onCloseAssign);
                self.onCloseRedirect = null;
                self.onCloseAssign = null;
                self.onCloseReload = false;
            }, 20);
        } else if (self.onCloseReload) {
            setTimeout(function () {
                urlSafe.reload();
                self.onCloseRedirect = null;
                self.onCloseAssign = null;
                self.onCloseReload = false;
            }, 20);
        }

        $('.nav-closer-animated', self.el).removeClass('ncafull');

        if (self.modalManagerToken) {
            ModalManager.close(self.modalManagerToken);
            self.modalManagerToken = null;
        }

        self.opened = false;

        var maxLeft = self.getMaxLeft();

        $(self.opener).addClass('nav-closed').removeClass('nav-opener-opened nav-opened');
        $(self.el).stop(true, false).animate({
            opacity: 0,
            left: '-' + maxLeft + 'px'
        }, self.conf.slide_speed.off, 'swing', function () {
            $([self.eloverlay, self.elbg]).css({
                opacity: 0
            }).addClass('hidden');
            $('body').removeClass('main-nav-opened');

            $(this).css({
                opacity: 0
            }).addClass('hidden');

            $(this).parent().css({
                zIndex: ''
            });

            $(this.opener).removeClass('nav-closed');
        });



    };


    addEventListener('customDialog:closing', () => {
        if (self.opened) {
            self.onCloseRedirect = null;
            self.onCloseAssign = null;
        }
    });
    appState.events.on('historySafeNavigateAway', (url, method) => {
        if (self.opened) {
            self.onCloseRedirect = method === 'redirect' ? url : null;
            self.onCloseAssign = method === 'assign' ? url : null;
            self.onCloseReload = method === 'reload';
            setTimeout(function () {
                self.close();
            }, 20);
            return false;
        }
    });

    self.init();
}
export function setMobileNavInstance(instance) {
    mobileNavInstance = instance;
}
export function getMobileNavInstance() {
    return mobileNavInstance;
}
